import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import LoginSeguro from './LoginSeguro';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleEmailPasswordLogin = async (email, password) => {
    console.log('[LOGIN] Submit started');
    setLoading(true);
    setErrorMessage(null);

    try {
      console.log('[LOGIN] Calling login...');
      const usuario = await login(email, password);
      console.log('[LOGIN] Login successful, user:', usuario);
      
      toast.success('Login realizado com sucesso!');
      
      // Redirect based on role
      console.log('[LOGIN][NAV] Navigating to:', usuario.papel === 'admin' ? '/admin' : '/usuario');
      if (usuario.papel === 'admin') {
        navigate('/admin');
      } else if (usuario.papel === 'medico') {
        navigate('/usuario');
      } else {
        navigate('/usuario'); // Default for ator
      }
    } catch (error) {
      console.error('[LOGIN] Error caught:', error);
      
      // Check for device-specific errors
      let message;
      if (error.deviceError === 'DEVICE_NOT_AUTHORIZED') {
        message = 'Este dispositivo não está autorizado. Contate o administrador.';
      } else if (error.deviceError === 'DEVICE_BLOCKED') {
        message = 'Este dispositivo foi bloqueado. Contate o administrador.';
      } else {
        message = error.response?.data?.detail || 'Erro ao fazer login';
      }
      
      setErrorMessage(message);
      toast.error(message);
    } finally {
      console.log('[LOGIN] Finally block - setting loading to false');
      setLoading(false);
    }
  };

  return (
    <LoginSeguro
      onSubmitEmailPassword={handleEmailPasswordLogin}
      loading={loading}
      errorMessage={errorMessage}
      logoSrc="/logo.png"
    />
  );
};

export default Login;